import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store firewalls data
    endpoint: endpoints.firewall.endpoint, // "loto-firewall"
    firewalls: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the firewalls data
    firewalls: state => state.firewalls,
    firewallByID: state => id => {
      for (const firewall of state.firewalls) {
        if (firewall.eid === id) return firewall;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.FIREWALLS_LOAD](state, firewalls) {
      state.firewalls = JSON.parse(JSON.stringify(firewalls));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetchByIDs: (context, paginationData) => {
      const ids = paginationData.ids;
      if (typeof ids === 'undefined') {
        console.error("firewall/fetchByIDs ids is undefined");
        return
      }
      const api = context.rootGetters['global/apiUrl'] + '/' + context.state.endpoint + '/' + ids.join(',') + ',';

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          params: {
            fields: paginationData.fields
          },
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.objects == null) r.data.objects = {}
              context.commit(types.FIREWALLS_LOAD, r.data.objects);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.FIREWALLS_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    create: (context, data) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'firewalls', {
        root: true
      });
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, data) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'firewalls', {
        root: true
      });
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    delete: (context, ids) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/deleteById";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: {
            ids
          },
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    bulkAction: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/bulkAction";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
